import { AdobeDataLayerPageViewPayload, DataLayerObject } from '@/types/AdobeAnalyticsDataLayer'
import { ADOBE_MAP } from './adobe-event-datas';
import { useFlow } from '@/store';
import { useGlobal } from '@/store';

function getSearchQueryParam(key: string, fallback = ''): string {
    const searchParams = new URLSearchParams(window.location.search)
    return searchParams.get(key) || fallback
}

export function addAdobeDataLayerPageView(payload: AdobeDataLayerPageViewPayload): void {
    window.adobeDataLayer = window.adobeDataLayer || [];
    window.adobeDataLayer.push({
        event: "page-view",
        web: {
            page: {
                name: `kbyg:${payload?.pageName}`
            },
            site: {
                name: "kbyg"
            }
        },
        user: {
            classId: getSearchQueryParam('classid'), // From %Client ID% data element
            group: {
                identifier: getSearchQueryParam('groupid') // From %Active Group ID% data element
            }
        },
        selection: {
            flow: {
                name: payload.flowName || null
            },
            options: payload.options || []
        },
        environment: {
            sys: "UAT",
            url: window.location.href,
            host: window.location.hostname
        },
        technical: {
            dataLayerVersion: "2.0.1"
        }
    }) as DataLayerObject
}

export function addAdobeDataLayerEventGetOffer(): void {
    window.adobeDataLayer.push({
        event: "get-offer",
        eventInfo: {
            linkName: "get-offer",
            linkType: "other"
        },
        action: {
            getOffer: 1
        },
        user: {
            classId: getSearchQueryParam('classid'), // From %Client ID% data element
            group: {
                identifier: getSearchQueryParam('groupid') // From %Active Group ID% data element
            }
        }
    }) as DataLayerObject
}

export function addAdobeDataLayerEventProviderSearch(): void {
    window.adobeDataLayer.push({
        event: "provider-search",
        eventInfo: {
            linkName: "provider-search",
            linkType: "other"
        },
        action: {
            providerSearch: 1
        },
        user: {
            classId: getSearchQueryParam('classid'), // From %Client ID% data element
            group: {
                identifier: getSearchQueryParam('groupid') // From %Active Group ID% data element
            }
        }
    }) as DataLayerObject
}

export function addAdobeDataLayerEventEditSelection(): void {
    window.adobeDataLayer.push({
        event: "edit-selection",
        eventInfo: {
            linkName: "edit-selection",
            linkType: "other"
        },
        action: {
            providerSearch: 1
        },
        user: {
            classId: getSearchQueryParam('classid'), // From %Client ID% data element
            group: {
                identifier: getSearchQueryParam('groupid') // From %Active Group ID% data element
            }
        }
    }) as DataLayerObject
}

export function addAdobeDataLayerEventSeeMore(): void {
    window.adobeDataLayer.push({
        event: "see-more",
        eventInfo: {
            linkName: "see-more",
            linkType: "other"
        },
        action: {
            seeMore: 1
        },
        user: {
            classId: getSearchQueryParam('classid'), // From %Client ID% data element
            group: {
                identifier: getSearchQueryParam('groupid') // From %Active Group ID% data element
            }
        }
    }) as DataLayerObject
}

export function addAdobeDataLayerEventBack(): void {
    window.adobeDataLayer.push({
        event: "back",
        eventInfo: {
            linkName: "back",
            linkType: "other"
        },
        action: {
            back: 1
        },
        user: {
            classId: getSearchQueryParam('classid'), // From %Client ID% data element
            group: {
                identifier: getSearchQueryParam('groupid') // From %Active Group ID% data element
            }
        }
    }) as DataLayerObject
}

export function addAdobeDataLayerEventExitBeforeFinish(payload: AdobeDataLayerPageViewPayload): void {
    window.adobeDataLayer.push({
        event: "exit-before-finish",
        eventInfo: {
            linkName: "exit-before-finish",
            linkType: "other"
        },
        action: {
            exitBeforeFinish: 1
        },
        web: {
            page: {
                name: `kbyg:${payload?.pageName}`
            }
        },
        user: {
            classId: getSearchQueryParam('classid'), // From %Client ID% data element
            group: {
                identifier: getSearchQueryParam('groupid') // From %Active Group ID% data element
            }
        }
    }) as DataLayerObject
}

export function trackSelectionEventCJA(oldEventKey: keyof typeof ADOBE_MAP): void {
    const flowStore = useFlow();
    const globalStore = useGlobal()
    const price = flowStore?.pricingSummary

    const newEvent = ADOBE_MAP[oldEventKey];

    if (!newEvent) {
        console.warn(`Event key "${String(oldEventKey)}" not found in Registry.`);
        return;
    }

    if (newEvent.event === 'price-display') {
        newEvent.price = {
            'retail': price.totalCharge, // From %Retail Price% data element
            'savings': price.saving, // From %Savings Amount% data element
            'moop': price.totalMoop, // From %MOOP% data element
            'plus': price.totalMoop, // From %Plus Price% data element
            'nonPlus': price.totalMoopNonPlus, // From %NonPlus Price% data element
            'currency': "USD" // From %Currency Code% data element
        }

    }

    if (typeof window !== 'undefined' && window.adobeDataLayer) {
        newEvent.user = {
            clientId: globalStore?.clientId,
            group: {
                identifier: globalStore?.groupId // From %Active Group ID% data element
            }
        }
        window.adobeDataLayer.push(newEvent);
    } else {
        console.error('Adobe Layer not initialized');
    }
}